class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.STORAGE_KEY = 'mtij:recently-viewed';
    this.limit = parseInt(this.dataset.limit, 10) || 4;
    this.currentHandle = (this.dataset.currentHandle || '').trim();
    this.grid = this.querySelector('[data-grid]');
    try {
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'fr-FR', {
        style: 'currency',
        currency: this.dataset.currency || 'EUR'
      });
    } catch (e) {
      this.formatter = { format: (v) => v.toFixed(2).replace('.', ',') + ' €' };
    }
    this.render();
  }

  getHandles() {
    try {
      const raw = window.localStorage.getItem(this.STORAGE_KEY) || '[]';
      const handles = JSON.parse(raw);
      if (!Array.isArray(handles)) return [];
      const filtered = this.currentHandle
        ? handles.filter((h) => h !== this.currentHandle)
        : handles;
      return filtered.slice(0, this.limit);
    } catch (e) {
      return [];
    }
  }

  async fetchProduct(handle) {
    try {
      const response = await fetch('/products/' + encodeURIComponent(handle) + '.js');
      if (!response.ok) return null;
      return await response.json();
    } catch (e) {
      return null;
    }
  }

  async render() {
    if (!this.grid) {
      this.remove();
      return;
    }
    const handles = this.getHandles();
    if (!handles.length) {
      this.remove();
      return;
    }
    const products = await Promise.all(handles.map((h) => this.fetchProduct(h)));
    const valid = products.filter(Boolean);
    if (!valid.length) {
      this.remove();
      return;
    }
    this.grid.innerHTML = valid.map((p) => this.renderCard(p)).join('');
    this.classList.remove('is-loading');
    this.classList.add('is-loaded');
    this.removeAttribute('hidden');
  }

  renderCard(product) {
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const imageUrl = image
      ? (image.includes('?') ? image + '&width=600' : image + '?width=600')
      : '';
    const showVendor = this.dataset.showVendor === 'true';
    const vendor = showVendor && product.vendor
      ? '<p class="recently-viewed-mtij__card-vendor">' + this.escape(product.vendor) + '</p>'
      : '';
    const soldOut = product.available === false
      ? '<span class="recently-viewed-mtij__card-soldout">' + this.escape(this.dataset.i18nSoldOut || 'Sold out') + '</span>'
      : '';
    const price = this.formatter.format((product.price || 0) / 100);
    const compareAt = product.compare_at_price && product.compare_at_price > product.price
      ? '<s>' + this.formatter.format(product.compare_at_price / 100) + '</s>'
      : '';
    const altText = (product.featured_image && product.featured_image.alt) || product.title;

    return [
      '<a class="recently-viewed-mtij__card" href="' + this.escape(product.url) + '" role="listitem">',
      '<div class="recently-viewed-mtij__card-media">',
      soldOut,
      imageUrl
        ? '<img class="recently-viewed-mtij__card-image" src="' + this.escape(imageUrl) + '" alt="' + this.escape(altText) + '" loading="lazy">'
        : '',
      '</div>',
      '<div class="recently-viewed-mtij__card-details">',
      vendor,
      '<h3 class="recently-viewed-mtij__card-title">' + this.escape(product.title) + '</h3>',
      '<p class="recently-viewed-mtij__card-price">',
      compareAt,
      '<span>' + price + '</span>',
      '</p>',
      '</div>',
      '</a>'
    ].join('');
  }

  escape(str) {
    const div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }
}

if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', RecentlyViewed);
}
